import { Component } from '@angular/core';
import { BackgroundComponent } from '../background/background.component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-erro404-page',
  imports: [BackgroundComponent, RouterLink],
  templateUrl: './erro404-page.component.html',
  styleUrl: './erro404-page.component.css'
})
export class Erro404PageComponent {

}
